import { render } from "./ModalOffComponent.vue?vue&type=template&id=1224b233&scoped=true"
import script from "./ModalOffComponent.vue?vue&type=script&lang=js"
export * from "./ModalOffComponent.vue?vue&type=script&lang=js"

import "./ModalOffComponent.vue?vue&type=style&index=0&id=1224b233&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1224b233"]])

export default __exports__